import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorMyFeeRates = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12 5.75a.75.75 0 0 1 .75.75v.75h1.393a.75.75 0 0 1 0 1.5H11a1.25 1.25 0 1 0 0 2.5h2a2.75 2.75 0 1 1 0 5.5h-.25v.75a.75.75 0 0 1-1.5 0v-.75H9.857a.75.75 0 0 1 0-1.5H13a1.25 1.25 0 1 0 0-2.5h-2a2.75 2.75 0 1 1 0-5.5h.25V6.5a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorMyFeeRates;
